import Page, { getStaticProps as compGetStaticProps } from 'components/pages/PasswordReset';

export const getStaticProps = compGetStaticProps;
export default Page;
